module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/ko/1-973419d78b2e53ea496f33e48298aa3a.jpg";